import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImpersonationActiveUser, ImpersonationMenuUser } from 'AccountsApp/ts/interfaces/impersonation.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class ImpersonationService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    /**
     * Impersonate a user by their email.
     * NOTE: Window must be refreshed after a successful response.
     */
    impersonateUser(targetUserEmail: string): Observable<HttpResponse<ImpersonationActiveUser>> {
        const url = this.urlsService.ACCOUNTS.IMPERSONATE_USER;
        const postParams = { target_user_email: targetUserEmail };
        return this.ajaxService.postFormEncodedDataObserveResponse<ImpersonationActiveUser>(url, postParams);
    }

    /**
     * End impersonation.
     * NOTE: Window must be refreshed after a successful response if active user is changed.
     */
    endImpersonation(): Observable<HttpResponse<ImpersonationActiveUser>> {
        const url = this.urlsService.ACCOUNTS.END_IMPERSONATION;
        return this.ajaxService.postFormEncodedDataObserveResponse<ImpersonationActiveUser>(url, {});
    }

    getImpersonationMenu(): Observable<ImpersonationMenuUser[]> {
        const url = this.urlsService.ACCOUNTS.IMPERSONATION_MENU;
        return this.ajaxService.getDataObserveBody<ImpersonationMenuUser[]>(url);
    }
}
